// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#scrollSearch[data-v-15996c36]{scroll-behavior:smooth}#scrollSearch[data-v-15996c36]::-webkit-scrollbar{width:8px}#scrollSearch[data-v-15996c36]::-webkit-scrollbar-thumb{border-radius:16px;background:#6de6dd}#scrollSearch[data-v-15996c36]::-webkit-scrollbar-thumb:hover{background:#30d5c9}#scrollSearch[data-v-15996c36]::-webkit-scrollbar-track{border-radius:16px;background:#e3fffd}", ""]);
// Exports
module.exports = exports;
